'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import Navbar from './navbar';
import { shouldHideAppChrome } from './navbar-visibility';

export default function ConditionalNavbar() {
  const pathname = usePathname();
  // Resolved after mount to avoid an SSR/CSR hydration mismatch on the host check.
  // Initial (null) render = pathname-only decision, matching the server output.
  const [hostname, setHostname] = useState<string | null>(null);
  useEffect(() => {
    setHostname(window.location.hostname);
  }, []);

  if (shouldHideAppChrome(pathname, hostname)) {
    return null;
  }

  // Show navbar for other authenticated pages that aren't dashboard
  return <Navbar />;
}